import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-generic-message',
    templateUrl: './generic-message.component.html',
    styleUrls: ['./generic-message.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class GenericMessageComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<GenericMessageComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  message!: string;

  ngOnInit(): void {
    this.message = this.data.message;
  }

  close(): void {
    this.dialogRef.close();
  }

}
